<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'

interface Props {
  image?: string
  imageAlt?: string
  title?: string
  description?: string
  ctaLabel: string
  visible?: boolean
}

withDefaults(defineProps<Props>(), { visible: true })

const emit = defineEmits<{ (e: 'ctaClick'): void }>()
</script>

<template>
  <div class="revalidation-banner-group">
    <div v-if="visible" class="revalidation-banner">
      <SharedSmoothImage
        :src="image"
        :alt="imageAlt"
        class="revalidation-banner-image"
      />

      <div class="revalidation-banner-content">
        <div class="revalidation-banner-title">
          {{ title }}
        </div>

        <div class="revalidation-banner-description fonts-body-medium-regular">
          {{ description }}
        </div>

        <SolButton id="btn-revalidation-pending" size="small" class="revalidation-banner-cta" @click="emit('ctaClick')">
          {{ ctaLabel }}
        </SolButton>
      </div>
    </div>

    <slot />
  </div>
</template>

<style scoped lang="scss">
.revalidation-banner-group {
  .revalidation-banner {
    @apply flex flex-col;
    @apply rounded-t-md overflow-hidden shadow-weak;
    background: linear-gradient(90deg, #EFFFC1 0%, #F7FFE6 60%, #FFFFFF 100%);

    @screen md:system {
      @apply flex-row items-stretch h-100px;
    }

    .revalidation-banner-image {
      @apply block w-full h-140px;

      @screen md:system {
        @apply w-325px h-100px;
      }
    }

    .revalidation-banner-content {
      @apply flex flex-col items-start gap-3 p-2xs;

      @screen md:system {
        @apply flex-row items-center gap-4 p-8 flex-1;
      }
    }

    .revalidation-banner-title {
      @apply text-brand-primary-pure;
      font-family: 'Grotesk', sans-serif;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.15;
      letter-spacing: 0;

      @screen md:system {
        width: 240px;
        flex-shrink: 0;
      }
    }

    .revalidation-banner-description {
      @apply text-neutral-low-medium fonts-body-medium-regular;

      @screen md:system {
        width: 310px;
        flex-shrink: 0;
      }
    }

    .revalidation-banner-cta {
      @apply w-full;

      @screen md:system {
        @apply w-auto flex-shrink-0;
      }
    }
  }
}
</style>
